import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaSearch } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import DashboardComponent from "./DashboardComponent";
import { API_URL, UPLOADS_API_URL } from "./config";
import Swal from 'sweetalert2';

function SoftworksAdminAccountQoutation() {
    const userId = localStorage.getItem('user_id');
    const companyId = localStorage.getItem('company_id');
    const branchId = localStorage.getItem('branch_id');
    const [username, setUsername] = useState(localStorage.getItem('userName'));
    const shiftDetails = JSON.parse(localStorage.getItem('shiftDetails'));
    const dateTimeOpen = shiftDetails ? shiftDetails.date_time_open : "Not available";    

    const [currency, setCurrency] = useState('');
    const [currencies, setCurrencies] = useState([]);

    const location = useLocation();
    const navigate = useNavigate();

    const companyName = localStorage.getItem('companyName') || "REMS ANYTHING";
    const branchName = localStorage.getItem('branchName') || "Branch: ";
    const shiftId = shiftDetails ? shiftDetails.shift_id : null;

    const [products, setProducts] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [companyDetails, setCompanyDetails] = useState({});
    const [branchDetails, setBranchDetails] = useState({});
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [selectedGoods, setSelectedGoods] = useState([]);
    const [quantity, setQuantity] = useState(1);
    const [loading, setLoading] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null); 

    useEffect(() => {
        const fetchProducts = async () => {
            const url = `${API_URL}/productdefinition/full_products_definitions_by_company_id_branch_id/${companyId}/${branchId}`;
            try {
                const response = await fetch(url);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const fetchedProducts = await response.json();
                console.log('Fetched Products:', fetchedProducts);
                setProducts(fetchedProducts);
            } catch (error) {
                console.error('Error fetching products:', error);
            }
        };

        const fetchCustomers = async () => {
            try {
                const response = await fetch(`${API_URL}/companysetup`);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                console.log('Fetched Customers:', data);
                setCustomers(data);
            } catch (error) {
                console.error('Error fetching customers:', error);
            }
        };

        const fetchCompanyDetails = async () => {
            try {
                const response = await fetch(`${API_URL}/companysetup/${companyId}`);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                console.log('Fetched Company Details:', data);
                setCompanyDetails(data);
            } catch (error) {
                console.error('Error fetching company details:', error);
            }
        };

        const fetchBranchDetails = async () => {
            try {
                const response = await fetch(`${API_URL}/branch/${branchId}`);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                console.log('Fetched Branch Details:', data); 
                setBranchDetails(data);
            } catch (error) {
                console.error('Error fetching branch details:', error);
            }
        };

        fetchProducts();
        fetchCustomers();
        fetchCompanyDetails();
        fetchBranchDetails();
    }, [companyId, branchId]);

    useEffect(() => {
        if (searchTerm) {
            const results = products.filter(product =>
                product.product_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                product.product_code.toLowerCase().includes(searchTerm.toLowerCase())
            ).slice(0, 3);
            setFilteredProducts(results);
        } else {
            setFilteredProducts([]);
        }
    }, [searchTerm, products]);

    const handleProductSelect = (product) => {
        setSearchTerm(product.product_name);
        setQuantity(1);
        setFilteredProducts([]);
    };

    const handleAddToSellList = () => {
        if (searchTerm) {
            const selectedProduct = products.find(product => product.product_name === searchTerm);
            if (quantity > 0) {
                const productToAdd = {
                    ...selectedProduct,
                    quantity: quantity,
                    total: selectedProduct.selling_price * quantity
                };
                setSelectedGoods(prev => [...prev, productToAdd]);
                setSearchTerm("");
                setQuantity(1);
            }
        }
    };

    const handleClearTransaction = () => {
        setSelectedGoods([]);
        setQuantity(1); // Reset quantity
    };

    const handleCompletePurchase = async () => {
        if (!selectedCustomer) {
            Swal.fire('Error', 'Please select a customer.', 'error');
            return;
        }

        setLoading(true);

        const totalAmount = selectedGoods.reduce((total, item) => total + item.total, 0);

        const postBody = {
            propertyid: "",
            company_id: companyId,
            branch_id: branchId,
            project: "",
            daterec: new Date().toISOString().split('T')[0],
            timerec: new Date().toTimeString().split(' ')[0],
            datefor: new Date().toISOString().split('T')[0],
            description: "InStore POS Sale",
            quantity: 0,
            combined_receipt_total_quantity: selectedGoods.reduce((total, item) => total + item.quantity, 0),
            amntrec: 0.00, 
            amntrec_credit: totalAmount, 
            interest: 0.00,
            principal: 0.00,
            deposit: 0.00,
            balance: 0.00,
            receipt_ref_dispatch_locked: "UNLOCKED",
            feesdue: 0.00,
            username: username,
            confirmed_by: "AUTO",
            authorized_by: "AUTO",
            branch: branchName,
            dispatch_status: "DISPATCHED",
            dispatch_by: "AUTO",
            dispatch_date: new Date().toISOString().split('T')[0],
            dispatch_time: new Date().toTimeString().split(' ')[0],
            dispatched_quantity: 0,
            undispatched_quantity_remaining: 0,
            undispatched_inventory_release_date: "0000-00-00",
            dispatch_sales_shift_id: shiftId,
            sales_shifts_id: shiftId,
            folio: "CAS",
            pmode: "CASH",
            currency: currency,
            price: 0.00,
            usd_price: 0.00,
            usd_cost_per_unit: 0.00,
            credit_repayment_currency_price: 0.00,
            ref: "00000",
            vat_rate_charged: 0.15,
            vat_invoice_no: "00000",
            discount_requisition_id: "0",
            discount_amount: 0.00,
            discount_cost: 0.00,
            monthsbehind: 0,
            movementafterpayment: 0,
            suspencebal: 0.00,
            suspencedr: 0.00,
            suspencecr: 0.00,
            suspencenarration: "0.00",
            marketing_media_sale_origin: "Online",
            marketing_loyalty_structure_id: "00000",
            customerid: selectedCustomer.company_id, 
            comment: "00000",
            sync_status: "00000"
        };

        console.log("Posting Sale Transaction:", postBody);

        try {
            const response = await fetch(`${API_URL}/salepostransqoutation/add_sale_pos_trans_sold_qoutation`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(postBody),
            });

            if (!response.ok) {
                throw new Error("Network response was not ok");
            }

            const result = await response.json();
            const currentTrans = result.result.insertId;

            const generateConfirmationCode = () => Math.floor(100000 + Math.random() * 900000).toString();
            const driver_confirmation_code1 = generateConfirmationCode();
            const driver_confirmation_code2 = generateConfirmationCode();

            for (const product of selectedGoods) {
                const saleRecord = {
                    company_id: companyId,
                    branch_id: branchId,
                    sale_records_id: currentTrans,
                    product_id: product.product_id,
                    quantity: product.quantity,
                    unit_cost: product.unit_cost,
                    selling_price: product.selling_price,
                    driver_confirmation_code1,
                    driver_confirmation_code2
                };
                console.log("Posting Sale Record:", saleRecord);
                try {
                    const saleResponse = await fetch(`${API_URL}/salelistqoutation/`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(saleRecord),
                    });
                    if (!saleResponse.ok) {
                        throw new Error("Failed to post sale record");
                    }
                } catch (error) {
                    console.error("Error posting sale record:", error);
                }
            }

            for (const dispatchList of selectedGoods) {
                const dispatchBody = {
                    company_id: companyId,
                    branch_id: branchId,
                    sale_records_id: currentTrans,
                    product_id: dispatchList.product_id,
                    quantity: dispatchList.quantity,
                };

                console.log("Posting Dispatch Record:", dispatchBody);
                await fetch(`${API_URL}/inventorymgt/dispatch`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(dispatchBody),
                });
            }

            const receiptDetails = {
                paymentId: currentTrans,
                selectedGoods,
                totalAmount: totalAmount, // Use totalAmount here
                operatorName: username,
                branchName: branchName,
                shiftId: shiftId,
                customer: selectedCustomer, 
                companyDetails,
                branchDetails, 
            };
            console.log("Receipt Details:", receiptDetails); 
            console.log("Customer Details:", selectedCustomer); // Log customer details

            navigate("/ReceiptQoutation", {
                state: receiptDetails,
            });

            handleClearTransaction();
        } catch (error) {
            console.error("Error completing purchase:", error);
        }
        setLoading(false);
    };

    return (
        <DashboardComponent>
            <div className="container-fluid" style={{
                backgroundColor: "#f8f9fa",
                minHeight: "100vh",
                padding: "20px",
                marginTop: "30px",
                width: "100%",
            }}>
                <div className="row">
                    {/* Company Details Card */}
                    <div className="col-md-6">
                        <div className="card h-100 shadow-sm border-0 rounded-3">
                            <div className="card-body text-center">
                                <img
                                    src={`${UPLOADS_API_URL}/${companyDetails.horizontal_logo?.replace(/\\/g, "/")}`}
                                    alt={`${companyDetails.name} Logo`}
                                    style={{
                                        width: '100%',
                                        height: 'auto',
                                        maxHeight: '150px',
                                        objectFit: 'contain',
                                        marginBottom: '10px'
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Branch Details Card */}
                    <div className="col-md-6">
                        <div className="card h-100 shadow-sm border-0 rounded-3">
                            <div className="card-body text-start">
                                <h5 className="card-title">{branchDetails.branch_name}</h5>
                                <h5 className="card-title">{companyDetails.name}</h5>
                                <p className="card-text"><strong>Registration Number:</strong> {companyDetails.registration_number}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <header className="my-3 text-center">
                    <h1 className="my-3" style={{ color: "red", fontSize: "1.8rem", fontWeight: 'bold' }}>Account Qoutation</h1>
                </header>

                {loading && (
                    <div className="loading-overlay">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p>Processing your transaction...</p>
                    </div>
                )}

                <div className="row">
                    <div className="col-md-8 col-sm-12">
                        <div className="mb-3">
                            <div className="input-group">
                                <select
                                    className="form-control"
                                    style={{ borderRadius: 0, backgroundColor: "#fff", height: "40px" }}
                                    onChange={(e) => {
                                        const selectedCustomerId = e.target.value;
                                        const customer = customers.find(c => c.company_setup_id.toString() === selectedCustomerId); // Ensure comparison is correct
                                        setSelectedCustomer(customer); // Update selected customer
                                        console.log("Selected Customer Details:", customer ? customer : "No customer selected"); // Log customer details
                                    }}
                                >
                                    <option value="">Select Customer</option>
                                    {customers.map(customer => (
                                        <option key={customer.company_setup_id} value={customer.company_setup_id}>
                                            {customer.name}
                                        </option>
                                    ))}
                                </select>

                                <input
                                    type="number"
                                    className="form-control"
                                    placeholder="Qty"
                                    style={{ borderRadius: 0, backgroundColor: "#fff", width: "70px", height: "40px" }}
                                    value={quantity}
                                    onChange={(e) => setQuantity(e.target.value)}
                                    min="1"
                                />

                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Scan or type item name"
                                    style={{ borderRadius: 0, backgroundColor: "#fff", height: "40px" }}
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />

                                <div className="input-group-append">
                                    <span className="input-group-text me-2" style={{ borderRadius: 0, backgroundColor: "#fff", height: "40px" }}>
                                        <FaSearch />
                                    </span>
                                </div>

                                <button 
                                    className="btn btn-primary px-2" 
                                    style={{ height: "40px", fontSize: "1rem" }}
                                    onClick={handleAddToSellList}
                                >
                                    Add
                                </button>
                            </div>

                            {filteredProducts.length > 0 && searchTerm && (
                                <ul className="list-group">
                                    {filteredProducts.map(product => (
                                        <li
                                            key={product.product_id}
                                            className="list-group-item list-group-item-action"
                                            onClick={() => handleProductSelect(product)}
                                        >
                                            {product.product_name} - {product.product_code}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>

                        <div>
                            <div className="mb-3" style={{
                                height: "200px",
                                overflowY: "scroll",
                                border: "1px solid #ccc",
                                padding: "10px",
                                textAlign: "left",
                            }}>
                                <h4 style={{ color: "#333", fontSize: "1.2rem" }}>Selected Goods</h4>
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>Product ID</th>
                                            <th>Product Code</th>
                                            <th>Description</th>
                                            <th>Unit Cost</th>
                                            <th>Quantity</th>
                                            <th>VAT</th>
                                            <th>Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {selectedGoods.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.product_id}</td>
                                                <td>{item.product_code}</td>
                                                <td>{item.product_name}</td>
                                                <td>{item.selling_price}</td>
                                                <td>{item.quantity}</td>
                                                <td>{0}</td>
                                                <td>{item.total.toFixed(2)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 col-sm-12">
                        <div>
                            <div className="row mb-3">
                                <h4 style={{
                                    fontSize: "1.5rem",
                                    fontWeight: "bold",
                                    textAlign: "left",
                                    color: "#333",
                                }}>
                                    Total Cost: {selectedGoods.reduce((total, item) => total + item.total, 0).toFixed(2)} USD
                                </h4>
                            </div>

                            <div className="row mb-3">
                                <div className="col text-start">
                                    <label style={{ fontSize: "1rem" }}>Currency</label>
                                    <select
                                        className="form-control"
                                        value={currency}
                                        onChange={(e) => setCurrency(e.target.value)}
                                    >
                                        <option value="USD">USD</option>
                                        <option value="ZWL">ZWL</option>
                                        <option value="ZAR">ZAR</option>
                                        <option value="GBP">GBP</option>
                                    </select>
                                </div>
                            </div>

                            <div className="d-flex justify-content-center mt-3">
                                <button 
                                    className="btn btn-success me-2" 
                                    style={{ fontSize: "0.9rem"}} 
                                    onClick={handleCompletePurchase}
                                >
                                    Complete Qoutation
                                </button>
                                <button 
                                    className="btn btn-primary" 
                                    style={{ fontSize: "0.9rem" }} 
                                    onClick={handleClearTransaction}
                                >
                                    Clear Qoutation
                                </button>
                            </div>
                        </div>
                    </div>

                    <footer className="mt-4 text-center" style={{ fontSize: "0.9rem" }}>
                        <div className="row">
                            <div className="col">
                                <p style={{ color: "#333" }}>Company Name:<span style={{fontWeight: 'bold'}}>{companyDetails.name}</span> </p>
                            </div>
                            
                            <div className="col">
                                <p style={{ color: "#333" }}>Shift ID: <span style={{fontWeight: 'bold'}}>{shiftDetails ? shiftDetails.shift_id : "No active shift"}</span> </p>
                            </div>
                            <div className="col">
                                <p style={{ color: "#333" }}>Shift Open Time: <span style={{fontWeight: 'bold'}}>{dateTimeOpen}</span></p>
                            </div>
                            <div className="col">
                                <p style={{ color: "#333" }}>Till Operator: <span style={{fontWeight: 'bold'}}>{username}</span></p>
                            </div>
                        </div>

                        <hr />
                    </footer>
                </div>
            </div>
        </DashboardComponent>
    );
}

export default SoftworksAdminAccountQoutation;